import { Component, OnInit, Inject , ElementRef , AfterViewInit, HostListener} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThemeService } from '@services/theme.service';
import { AnalyticsService } from '@services/analytics.service';

@Component({
  selector: 'smione-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit, AfterViewInit {
  isPrivatePolicy:boolean = false;
  componentName : string = 'PrivacyPolicy';
  isShowSMSContent: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<PrivacyPolicyComponent>,
    private themeService: ThemeService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private analyticsService: AnalyticsService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.themeService.SetThemeInitially();
    if(this.dialogData['DisplayText'])
      this.isPrivatePolicy = true;
    this.isShowSMSContent = this.dialogData.isShowSMSContent;
  }

  ngAfterViewInit() {
    this.dialogRef.afterOpened().subscribe(() => {
      const dialogContainer = this.elementRef.nativeElement.closest('.mat-dialog-container');
      if (dialogContainer) {
        dialogContainer.setAttribute('aria-label', 'Privacy policy dialog');
      }
    });
   
    setTimeout(() => {
      const dialogContainer = this.elementRef.nativeElement.closest('.mat-dialog-container');
      if (dialogContainer && !dialogContainer.getAttribute('aria-label')) {
        dialogContainer.setAttribute('aria-label', 'Privacy policy dialog');
      }
    }, 0);
  }



  
  open(){ 
    this.analyticsService.gtag(this.componentName, `open`);
    this.dialogRef.close(this.dialogData['RedirectUrl']); 
  }

  close(){ 
    this.analyticsService.gtag(this.componentName, `close`);
    this.dialogRef.close(); 
  }
  @HostListener('document:keydown.escape')
  onEscape() {
    this.close();
  }
  
}
 